import { render } from "./ShortcutDialog.vue?vue&type=template&id=f40c0a16&scoped=true"
import script from "./ShortcutDialog.vue?vue&type=script&lang=js"
export * from "./ShortcutDialog.vue?vue&type=script&lang=js"

import "./ShortcutDialog.vue?vue&type=style&index=0&id=f40c0a16&scoped=true&lang=css"
import "./ShortcutDialog.vue?vue&type=style&index=1&id=f40c0a16&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f40c0a16"]])

export default __exports__